import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { OnsaMvpVmrPopulatorDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';

export const useSaveVMRData = (): {
    saveVMRData: (carDTO: OnsaMvpVmrPopulatorDTO) => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const saveVMRData = async (carVMRData: OnsaMvpVmrPopulatorDTO): Promise<void> => {
        await OnlineSalesUnauthenticated.saveVMRData(jobNumber, sessionId, carVMRData, !isLoggedOn);
    };

    return { saveVMRData };
};
